import { forwardRef } from 'react';
import { StyledBlockquote } from './styled';

const Blockquote = forwardRef((props, ref) => (
  <StyledBlockquote ref={ref} {...props} />
));

export default Blockquote;
